import { useEffect, useState, useMemo } from 'react';
import { generateLighthouseReportHtml } from '../../../../utils/lighthouseReport';

export const useLighthouseReport = (rawLighthouseReport, isModalOpen) => {
    const [isReportLoading, setIsReportLoading] = useState(false);
    const [lighthouseReportHtml, setLighthouseReportHtml] = useState('');
    const [lighthouseReportError, setLighthouseReportError] = useState('');

    const lighthouseReport = useMemo(() => {
        if (!rawLighthouseReport) {
            return null;
        }

        if (typeof rawLighthouseReport === 'string') {
            try {
                return JSON.parse(rawLighthouseReport);
            } catch (error) {
                console.error('Failed to parse lighthouse_report JSON.', error);
                return null;
            }
        }
        return rawLighthouseReport;
    }, [rawLighthouseReport]);

    useEffect(() => {
        let isCancelled = false;

        if (!isModalOpen || !lighthouseReport) {
            return () => {
                isCancelled = true;
            };
        }

        setIsReportLoading(true);
        setLighthouseReportError('');

        const loadReport = async () => {
            try {
                const html = await generateLighthouseReportHtml(lighthouseReport);

                if (!isCancelled) {
                    setLighthouseReportHtml(html);
                }
            } catch (error) {
                console.error('Failed to render Lighthouse report.', error);
                if (!isCancelled) {
                    setLighthouseReportHtml('');
                    setLighthouseReportError('Unable to render Lighthouse report.');
                }
            } finally {
                if (!isCancelled) {
                    setIsReportLoading(false);
                }
            }
        };

        loadReport();

        return () => {
            isCancelled = true;
        };
    }, [isModalOpen, lighthouseReport]);

    useEffect(() => {
        if (!isModalOpen) {
            setLighthouseReportHtml('');
            setLighthouseReportError('');
            setIsReportLoading(false);
        }
    }, [isModalOpen]);

    return {
        lighthouseReport,
        isReportLoading,
        lighthouseReportHtml,
        lighthouseReportError
    };
};






